import type { RequestParams, ScpClient } from '~shared/api/scp/client';

import type { Merchant } from '../../model/merchant';
import type { MerchantApi } from '../merchant-api';

interface Params {
  scpClient: ScpClient;
  host: string;
}

export class GatewayMerchantApi implements MerchantApi {
  client: ScpClient;
  host: string;

  constructor({ scpClient, host }: Params) {
    this.client = scpClient;
    this.host = host;
  }

  getMerchants(): Promise<Merchant[]> {
    return this.makeRequest<Merchant[]>({
      method: 'find-all-by-employee-id',
    }).then((response) => response.payload);
  }

  private makeRequest<T>(params: Partial<RequestParams> & { method: string }) {
    return this.client.call<T>({
      host: this.host,
      version: 'v1',
      domain: 'merchant-portal',
      service: 'public/merchants',
      withCredentials: true,
      withLeadingDomain: true,
      ...params,
    });
  }
}
